import { WALKTHROUGH } from '../actionTypes';

const initialState = {};

const walkthroughPopoverReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case WALKTHROUGH.CREATE_WALKTHROUGH_POPOVER_OBJ: {

            return {
                ...actions.payload
            };
        }
        default:
            return state;
    }

};

export default walkthroughPopoverReducer;